<template>
  <div class="filials-component">
    <div class="filials-section d-flex flex-column justify-end">
      <span class="filials-section-title">Филиал и адрес доставки:</span>

      <span v-show="!isPickup" class="filials-section-name">{{ curFilialName }}</span>
      <!--      <v-select
        v-model="selectedFilial"
        @change="changeFilial"
        :items="filials"
        item-text="name"
        item-value="id"
        hide-details="auto"
        class="select"
        background-color="#F1F3F6"
        height="42"
        :placeholder="`Выберите филиал`"
        solo
      />-->
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import DeliveryType from '@/models/enums/DeliveryType'

  export default {
    name: 'Filials',
    data () {
      return {
        selectedFilial: null,
      }
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        filials: state => state.branches.availableForOrderFilials,
      }),
      curFilialName () {
        return this.basket?.filial?.name
      },
      isPickup () {
        return this.basket?.deliveryType === DeliveryType.Self
      },
    },
    watch: {
      basket () {
        this.selectedFilial = this.basket.filialId
      },
    },
    mounted () {
      if (this.basket.filialId) {
        this.selectedFilial = this.basket.filialId
      }
    },
    methods: {
      changeFilial (value) {
        const data = {
          filialId: value,
        }
        const id = this.basket.id
        this.$store
          .dispatch('baskets/updateBasket', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
    },
  }
</script>

<style lang="less">
  .filials-component {
    margin-bottom: 10px;
    font-size: 12px;

    .media-xl({
      font-size: 14px;
    });

    .filials-section-title {
      font-size: 1em;
      margin-bottom: 0;
    }
    .v-text-field.v-text-field--solo .v-input__control {
      min-height: 3em;
    }

    .filials-section-name {
      color: @color-btn-dark-grey;
      padding-left: 10px;
      font-size: 0.9em;
    }
    .select {
      border-radius: 10px;
      margin: 5px 2px 0 2px;
      font-size: 1.14em;

      .v-input__slot {
        box-shadow: none !important;
        text-align: center;
      }

      svg {
        margin-right: 12px;
      }
    }
  }
</style>
